<mat-toolbar class="nr-footer" id="footerContainer">
  <mat-toolbar-row fxLayout="row" fxLayout.lt-md="column">

    <div class="dst-help" fxLayout="column" fxFlex="25" fxLayoutAlign="start">
      <a id="lnk-privacy-policy" href="/assets/documents/Privacy-Policy.pdf" target="_blank">
        <img src="assets/images/info.png" alt="" /> Privacy Policy
      </a>
      <a id="lnk-help" (click)="openHelpPage()">
        <img src="assets/images/help.png" alt="" /> Help
      </a>
    </div>

    <div class="ii-dst-version" fxLayout="column" fxFlex="50" id="dst-version-details">
      <div class="ii-dst-title" fxLayoutAlign="center center">My Infrastructure Manager</div>
      <div class="ii-dst-title" fxLayoutAlign="center center">© 2022 NETWORK RAIL</div>
    </div>

    <div class="footer-right" fxLayout="column" fxFlex="25" fxLayoutAlign="end end" id="footer-nr-logo">
      <img alt="Networkrail-Logo" src="assets/images/Networkrail-logo_white.png" class="nr-logo" />
    </div>

  </mat-toolbar-row>
</mat-toolbar>